import apiClient from './apiClient';

/**
 * Website booking widget (embed snippet) settings — BookingEngineConfig's
 * branding/default-currency/default-language fields, plus the room-type
 * and currency lists the "Website booking widget" page needs to generate
 * the embed snippet and per-room "Book this room" links.
 */
const bookingWidgetService = {
  getSettings: () => apiClient.get('/v1/settings/booking-widget'),
  updateSettings: (data) => apiClient.put('/v1/settings/booking-widget', data),
  regenerateKey: () => apiClient.post('/v1/settings/booking-widget/regenerate-key'),
};

export default bookingWidgetService;
